module.exports = "/_next/static/images/7179e2f04d44b2ba917d07fb2e3e6a60-hero-mobile-10.jpg";